namespace RecordShield.Modules.Workspace.SerialKeys {
    export enum AccessStatus {
        All = 1,
        Selected = 2
    }
    Serenity.Decorators.registerEnum(AccessStatus, 'SerialKeys.AccessStatus');
}
